/** @internal Turbopack `resolveAlias.browser` fallback. Do not import. */

const emptyStr = () => '';
const noop = () => undefined;

export const join = emptyStr;
export const resolve = emptyStr;
export const dirname = emptyStr;
export const basename = emptyStr;
export const extname = emptyStr;
export const normalize = emptyStr;
export const relative = emptyStr;
export const isAbsolute = () => false;
export const parse = () => ({ root: '', dir: '', base: '', name: '', ext: '' });
export const sep = '/';
export const delimiter = ':';

export const readFile = async () => '';
export const writeFile = async () => undefined;
export const readdir = async () => [] as string[];
export const stat = async () => undefined;
export const mkdir = async () => undefined;
export const readFileSync = () => '';
export const writeFileSync = noop;
export const mkdirSync = noop;
export const existsSync = () => false;

// eslint-disable-next-line import/no-anonymous-default-export
export default {
	join,
	resolve,
	dirname,
	basename,
	extname,
	normalize,
	relative,
	isAbsolute,
	parse,
	sep,
	delimiter,
	readFile,
	writeFile,
	readdir,
	stat,
	mkdir,
	readFileSync,
	writeFileSync,
	mkdirSync,
	existsSync,
};
